module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Thin.3ef35ba.woff2";